// extracted by mini-css-extract-plugin
export default {"fileList":"fileList__WsAZl","uploadedFile":"uploadedFile__ylFL4","closeIcon":"closeIcon__+71-2"};